import { render, staticRenderFns } from "./ShowItemDialog.vue?vue&type=template&id=379f053c"
import script from "./ShowItemDialog.vue?vue&type=script&lang=js"
export * from "./ShowItemDialog.vue?vue&type=script&lang=js"
import style0 from "./ShowItemDialog.vue?vue&type=style&index=0&id=379f053c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports